module.exports = __webpack_public_path__ + "img/price-1264x640.ae7a8ead.jpg";